import React from 'react';
import { Trans } from '@lingui/macro';
import { Result } from 'antd';

import { logger } from '../services/logger';
import { Button } from './button';

export interface ErrorResultProps {
  log?: {
    message: string;
    error?: Error | unknown;
    [key: string]: any;
  };
}

export const ErrorResult: React.FC<ErrorResultProps> = ({ log }) => {
  React.useEffect(() => {
    if (log) {
      const { message, error, ...context } = log;

      logger.error(message, { error: error as any, ...context });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Result
      status="error"
      title={
        <Trans id="ui.title.error.loading.content">Error loading content</Trans>
      }
      extra={[
        <Button key="reload" onClick={() => window.location.reload()}>
          <Trans id="ui.action.reload.page">Reload page</Trans>
        </Button>,
      ]}
    />
  );
};
